import React, { useRef } from "react";
import { Card, CardBody, Button } from "reactstrap";
import {
  DollarIcon,
  UserIcon,
  ClockIcon,
  ActivityIcon,
  ArrowUpIcon,
  ArrowLeft,
  ArrowRight
} from "../../assets/img/icons";
import "./SnowFlakeDashboard.scss";
// Sub-component for individual KPI Cards to reduce duplication
const KPICard = ({ label, value, icon, colorClass, footer }) => (
  <div className="kpi-scroll-item">
    <Card className="kpi-card glass-card h-100">
      <CardBody className="d-flex flex-column justify-content-center position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <p className="kpi-label">{label}</p>
            <h2 className={`kpi-value ${colorClass} mb-0`}>{value}</h2>
          </div>
          <div className={`kpi-icon bg-light ${colorClass} large`}>{icon}</div>
        </div>
        <div className="kpi-footer mt-3">{footer}</div>
      </CardBody>
    </Card>
  </div>
);

const SnowFlakeStats = ({
  totalCredits,
  totalConsumers,
  avgUsageDays,
  matchRate,
  trend
}) => {
  const scrollRef = useRef(null);

  const scroll = direction => {
    if (scrollRef.current) {
      const { clientWidth } = scrollRef.current;
      const scrollAmount =
        direction === "left" ? -(clientWidth / 2 + 10) : clientWidth / 2 + 10;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const cards = [
    {
      label: "Total Credits",
      value: totalCredits.toFixed(2),
      icon: <DollarIcon />,
      colorClass: "text-danger",
      footer: (
        <>
          <span
            className={`${
              trend.isUp ? "text-danger" : "text-success"
            } mr-2 font-weight-bold h5`}
          >
            <span
              style={{
                display: "inline-block",
                transform: trend.isUp ? "none" : "rotate(180deg)"
              }}
            >
              <ArrowUpIcon />
            </span>{" "}
            {trend.value}%
          </span>
          <span className="text-muted">vs prev. period</span>
        </>
      )
    },
    {
      label: "Active Consumers",
      value: totalConsumers,
      icon: <UserIcon />,
      colorClass: "text-blue",
      footer: (
        <span className="text-muted">Unique accounts active in period</span>
      )
    },
    {
      label: "Avg Usage Days",
      value: avgUsageDays,
      icon: <ClockIcon />,
      colorClass: "text-success",
      footer: (
        <span className="text-muted">Usage frequency per active consumer</span>
      )
    },
    {
      label: "Correlation Rate",
      value: `${matchRate}%`,
      icon: <ActivityIcon />,
      colorClass: "text-info",
      footer: (
        <span className="text-muted">
          Activity matched to historical spikes
        </span>
      )
    }
  ];

  return (
    <div className="position-relative mb-4 kpi-slider-container">
      <Button
        className="slider-nav-btn left d-none d-md-flex"
        onClick={() => scroll("left")}
      >
        <ArrowLeft />
      </Button>

      <div className="kpi-scroll-container" ref={scrollRef}>
        <div className="kpi-scroll-wrapper">
          {cards.map((card, index) => (
            <KPICard key={index} {...card} />
          ))}
        </div>
      </div>

      <Button
        className="slider-nav-btn right d-none d-md-flex"
        onClick={() => scroll("right")}
      >
        <ArrowRight />
      </Button>
    </div>
  );
};

export default SnowFlakeStats;
